import { render, staticRenderFns } from "./b-ticket-wrap.vue?vue&type=template&id=2ff4ac9e&scoped=true"
import script from "./b-ticket-wrap.vue?vue&type=script&lang=ts"
export * from "./b-ticket-wrap.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-wrap.vue?vue&type=style&index=0&id=2ff4ac9e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4ac9e",
  null
  
)

export default component.exports